export function getChain(...args: any) {
  let result = args[0];

  for (let i = 1; result && i < args.length; i++) {
    result = result[args[i]];
  }

  return result;
}
